import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option"]
  static classes = ["selected", "unselected"]

  connect() {
    this.updateVisualState()
  }

  select(event) {
    this.updateVisualState()
  }

  updateVisualState() {
    this.optionTargets.forEach(option => {
      const radio = option.querySelector('input[type="radio"]')
      const isChecked = radio && radio.checked

      // Update border and background
      if (isChecked) {
        option.classList.remove('border-slate-200', 'bg-white')
        option.classList.add('border-emerald-600', 'bg-emerald-50')
      } else {
        option.classList.remove('border-emerald-600', 'bg-emerald-50')
        option.classList.add('border-slate-200', 'bg-white')
      }

      // Update icon circle
      const iconCircle = option.querySelector('.icon-circle')
      if (iconCircle) {
        if (isChecked) {
          iconCircle.classList.remove('bg-slate-100')
          iconCircle.classList.add('bg-emerald-600')
          const svg = iconCircle.querySelector('svg')
          if (svg) {
            svg.classList.remove('text-slate-600')
            svg.classList.add('text-white')
          }
        } else {
          iconCircle.classList.remove('bg-emerald-600')
          iconCircle.classList.add('bg-slate-100')
          const svg = iconCircle.querySelector('svg')
          if (svg) {
            svg.classList.remove('text-white')
            svg.classList.add('text-slate-600')
          }
        }
      }

      // Update checkmark visibility
      const checkmark = option.querySelector('.checkmark')
      if (checkmark) {
        if (isChecked) {
          checkmark.classList.remove('opacity-0')
          checkmark.classList.add('opacity-100')
        } else {
          checkmark.classList.remove('opacity-100')
          checkmark.classList.add('opacity-0')
        }
      }
    })
  }
}
